<template>
  <div class="version">

    <h2>Release Info</h2>

    <div class="table">
      <div>Web Version</div> <div>{{version.webVersion}}</div>
      <div>Web Date</div>    <div>{{version.webDate}}</div>
      <div>API URL</div>     <div>{{version.apiURL}}</div>
      <div>API Version</div> <div>{{version.apiVersion}}</div>
    </div>

  </div>
</template>

<script>

  import axios from "axios";
  import {version, date} from "../../package.json"
  import TopNavbar from "@/layout/TopNavbar.vue";
  import ContentFooter from "@/layout/ContentFooter.vue";

  export default {
    components: {
      TopNavbar,
		  ContentFooter,
    },

    data() {
      return {
        version: {
          webVersion: version,
          webDate: date,
          apiURL: process.env.VUE_APP_API,
          apiVersion: ""
        }
      }
    },

    created(){
      axios.get(this.version.apiURL+"/openapi.json")
        .then(response => { this.version.apiVersion = response.data.info.version })
    }
  }

</script>

<style scoped>

  .version{
    margin: 5em 8%;

    h2 {
      font-weight: bold;
      color: #343434;
    }

    .table {
      display: grid;
      width: max-content;
      grid-template-columns: max-content max-content;
      gap: 1px;
      margin: 1em;
      background-color: #e5e5e5;

      div { padding: 0.5em 1em; }

      div:nth-child(odd) {
        font-weight: bold;
        background-color: #f0f0f0;
        text-align: end;
      }

      div:nth-child(even) { background-color: white; }

    }

    @media (max-width: 700px) {
      .table {
          grid-template-columns: 1fr;
          margin: 0;
          div:nth-child(odd) { text-align: start; }
          div:nth-child(even) { padding-bottom: 2em; }
      }
    }
  }

</style>
